window.swipers = [];

class SwiperSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.options = this.getAttribute('data-swiper') ? JSON.parse(this.getAttribute('data-swiper')) : {};
    // If the .swiper-slider element is not rendered yet
    // it could be necessary to add a timeout here.
    this.sliderSelector = this.querySelector('.swiper-slider')
    if (this.sliderSelector) {
      const swiper = new Swiper(this.sliderSelector, this.options);
      swiper && window.swipers.push(swiper);
    }
    this.pillsSlider();
    this.categoryCarousel();
    this.designerSlider();
  }

  categoryCarousel(){
    const carosello = this.querySelector(".category-carousel__swiper");
    if(carosello){
      // Carosello «What are you looking for?» degli hub (#1444): stesso scorrimento
      // libero della barra Styles (#1353, T12). Sui touch scorre il browser
      // (cssMode: inerzia nativa, nessun aggancio); su desktop frecce e
      // trascinamento con inerzia. Larghezze dei riquadri dal CSS (slidesPerView auto).
      const touch = window.matchMedia("(hover: none) and (pointer: coarse)").matches;
      const ridotto = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const swiperCarosello = new Swiper(carosello, {
        // lo spazio fra i riquadri è il margine CSS (16 px, presente prima dell'avvio):
        // Swiper lo conta già nella misura del riquadro, uno spaceBetween lo raddoppierebbe
        spaceBetween: 0,
        slidesPerView: "auto",
        cssMode: touch,
        speed: ridotto ? 0 : 300,
        watchOverflow: true,
        freeMode: {
          enabled: true,
          momentum: true,
          sticky: false
        },
        navigation: {
          nextEl: this.querySelector(".category-carousel__next"),
          prevEl: this.querySelector(".category-carousel__prev")
        },
        on: {
          afterInit: function(){
            this.el.closest(".category-carousel").classList.toggle("is-locked", this.isLocked);
          }
        }
      });
      swiperCarosello.on("lock unlock", () => {
        carosello.closest(".category-carousel").classList.toggle("is-locked", swiperCarosello.isLocked);
      });
    }
  }

  pillsSlider(){
    const pills = this.querySelector(".pills.swiper");
    if(pills){
      const overlay = this.querySelector(".opacity-component");
      // Scorrimento libero (#1353, T12): la barra si ferma dove la lascia il dito,
      // senza agganciarsi alla pill più vicina. Sui touch scorre il browser
      // (cssMode: inerzia nativa); i 10 px ai bordi li danno i margini CSS delle
      // pill estreme, perché Swiper 11.0.5 ignora gli offset in cssMode.
      const touch = window.matchMedia("(hover: none) and (pointer: coarse)").matches;
      const swiperPills = new Swiper(pills, {
        spaceBetween: 10,
        slidesPerView: "auto",
        slidesOffsetBefore: touch ? 0 : 10,
        slidesOffsetAfter: touch ? 0 : 10,
        cssMode: touch,
        freeMode: {
          enabled: true,
          momentum: true,
          sticky: false
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },

        breakpoints:{
          1024:{
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          }
        },

        on: {
          afterInit: function(){
            if(this.isLocked){
              this.el.closest(".pills-container").classList.add("is-locked");
            }
          }
        }
      });
      // sfumatura a destra finché c'è altro da scorrere ('progress' esce sia col trascinamento sia con lo scroll nativo)
      const aggiornaSfumatura = () => overlay.classList.toggle("hide", swiperPills.isEnd);
      aggiornaSfumatura();
      swiperPills.on("progress", aggiornaSfumatura);
    }
  }

  designerSlider(){
    const swiper = window.swipers.find( s => (s.el.matches(".letters-slider")))
    if (swiper) {
      swiper.on('reachEnd', () => {
        if(!this.querySelector(".opacity-component").classList.contains("hide")){
          this.querySelector(".opacity-component").classList.add("hide");
        }
      });
      swiper.on('slidePrevTransitionEnd', () => {
        if(this.querySelector(".opacity-component").classList.contains("hide")){
          this.querySelector(".opacity-component").classList.remove("hide");
        }
      });
    }
  }
}

customElements.define('swiper-slider', SwiperSlider);
